<!--
	@name app-common-fact-find-chips
	@description Status chips for a fact find row (view only / converted)
	@date 2020/06/03
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<span>
		<v-chip v-if="isViewOnly" color="error" small class="ml-2"> View Only </v-chip>
		<v-chip v-if="isConverted" color="warning" small class="ml-2"> Converted </v-chip>
	</span>
</template>

<script>
	export default {
		name: 'app-common-fact-find-chips',

		props: {
			item: {
				type: Object,
				required: true
			}
		},

		computed: {
			/**
			 * @name isViewOnly
			 * @description Fact find sits on the retired "legacy" question set, so WriteRoute renders it read-only
			 * @return {Boolean}
			 */
			isViewOnly() {
				return this.item.questionSetNameUnique === 'legacy';
			},

			/**
			 * @name isConverted
			 * @description Fact find is the copy produced by converting a legacy fact find to the default question set.
			 * `convertedFromBasic` is the pre-rename key, still present on records converted before the
			 * basic/recommended -> legacy/default rename, so both are checked.
			 * @return {Boolean}
			 */
			isConverted() {
				return !!(this.item.conversion?.convertedFromLegacy || this.item.conversion?.convertedFromBasic);
			}
		}
	};
</script>
